export const getDataFromInclude = (included, type, id = null) => {
  if (id) {
    return included.find((item) => item.type === type && item.id === id);
  }
  return included.find((item) => item.type === type);
};
